import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TreeTableTogglerComponent } from './treetabletoggler.component';

@NgModule({
  imports: [CommonModule],
  declarations: [TreeTableTogglerComponent],
  exports: [TreeTableTogglerComponent]
})
export class TreeTableTogglerModule {}
